__turbopack_context__.v({
  "root": "have-an-account-module-scss-module__hZlN9q__root",
  "sign_up": "have-an-account-module-scss-module__hZlN9q__sign_up",
});
